export const accountMenu = {
  roles: {
    collaborator: "Collaboratore",
    hostMode: "Modalità host",
  },
  header: {
    collaboratorAccess: "Accesso collaboratore",
  },
  panel: {
    label: "Vista pannello",
    apartment: "Appartamento",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Naviga",
    manage: "Gestisci",
  },
  items: {
    home: "Home",
    bookings: "Prenotazioni",
    myAccount: "Il mio account",
    myAccommodations: "I miei alloggi",
    aiReception: "Reception AI",
    aiReceptionist: "Receptionist AI",
    directBookings: "Prenotazioni dirette",
    website: "Sito web",
    logout: "Esci",
  },
  badges: {
    ai: "AI",
    new: "NUOVO",
  },
  actions: {
    close: "Chiudi",
  },
};
